module.exports = __webpack_public_path__ + "img/1666234387056-Jellyfish.jpg.af041e6b.webp";